import React, {FC} from 'react'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import ContainerWrapper from '../../componentes/Container'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {renderPanelContent} from '../components'

const LaundryPageGnerateBillingWrapper: FC = () => {
  const {currentTabItem} = useLavanderia()
  return (
    <ContainerWrapper>
      <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
        <Panel
          collapsible={true}
          order={1}
          key={`panel-lavanderia-header-${currentTabItem.id}`}
          id={`panel-lavanderia-header-${currentTabItem.id}`}
          className={'panel__box'}
        >
          <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
        </Panel>
        <>
          {currentTabItem.showPanel && (
            <>
              <ResizeHandle />
              <Panel
                className={'panel__box'}
                collapsible={true}
                defaultSize={50}
                order={2}
                key={`panel-lavanderia-detail-${currentTabItem.id}`}
                id={`panel-lavanderia-detail-${currentTabItem.id}`}
              >
                {renderPanelContent(currentTabItem.content.detailPanel)}
              </Panel>
            </>
          )}
        </>
      </PanelGroup>
    </ContainerWrapper>
  )
}

export default LaundryPageGnerateBillingWrapper
